import { cloneElement } from 'react';

import { Flex, cx } from '@endurancewarranty/ui';

import type { FC, JSX, ReactNode } from 'react';

type Props = Readonly<{
  backgroundClassName?: string;
  children: ReactNode;
  className?: string;
  iconClassName?: string;
  size?: 'sm' | 'md' | 'lg';
}>;

export const RoundedIcon: FC<Props> = ({
  backgroundClassName,
  children,
  className,
  iconClassName,
  size = 'md',
}) => {
  const child = children as JSX.Element;
  const iconSize = { sm: 20, md: 24, lg: 28 }[size];
  const style = cx(
    {
      'h-8 w-8': size === 'sm',
      'h-10 w-10': size === 'md',
      'h-12 w-12': size === 'lg',
      'bg-background-100': backgroundClassName == null,
    },
    'rounded-full',
    backgroundClassName,
    className,
  );

  return (
    <Flex className={style} items="center" justify="center">
      {cloneElement(child, {
        className: cx({ 'text-icon-primary': iconClassName == null }, iconClassName),
        width: iconSize,
        ...child.props,
      })}
    </Flex>
  );
};
